<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="text().title" size="md">
  <ng-template>
    <div class="birthdays-list">
      <div class="birthdays-range">{{ text().range }}</div>
      @if (error()) {
        <div class="birthdays-error">{{ error() }}</div>
      }
      @if (loading()) {
        <div class="birthdays-empty">{{ text().loading }}</div>
      } @else if (items().length === 0) {
        <div class="birthdays-empty">{{ text().empty }}</div>
      } @else {
        @for (item of items(); track item.id) {
          <button type="button" class="birthdays-row" (click)="openChart(item)">
            <i class="fas fa-cake-candles birthdays-icon" aria-hidden="true"></i>
            <span class="birthdays-date">{{ formatDate(item.nextBirthdayDate) }}</span>
            <span class="birthdays-name" [title]="item.name">{{ item.name }}</span>
            <span class="birthdays-age">{{ turnsText(item) }}</span>
          </button>
        }
      }
    </div>
  </ng-template>
</e-dialog>
